"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityAudit = void 0;
var SecurityAudit;
(function (SecurityAudit) {
    let ActivityType;
    (function (ActivityType) {
        ActivityType["login"] = "login";
        ActivityType["apiRequest"] = "apiRequest";
    })(ActivityType = SecurityAudit.ActivityType || (SecurityAudit.ActivityType = {}));
})(SecurityAudit = exports.SecurityAudit || (exports.SecurityAudit = {}));
//# sourceMappingURL=securityAudit.js.map